// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__39IaN","summary":"CartItem_summary__B4lJW","price":"CartItem_price__2s0L5","amount":"CartItem_amount__1dJeW","actions":"CartItem_actions__MUaEj"};